import approveProcessingApplicationReducer from "./approveProcessingApplicationReducer";
import approveProcessingApplicationDraftReducer from "./approveProcessingApplicationDraftReducer";

const approveProcessingApplicationReducers = {
    approveProcessingApplication: approveProcessingApplicationReducer,
    approveProcessingApplicationDraft: approveProcessingApplicationDraftReducer
};

export default approveProcessingApplicationReducers;